import type { ReactNode } from "react";
import { EventEmitter } from "events";

export interface ToastCustomProgress {
  customProgress?: number;
  message?: ReactNode;
  shouldHideToast?: boolean;
  toastId: string;
}

declare interface ToastCustomProgressEmitter {
  on(
    event: "onCustomProgress",
    listener: ({
      toastId,
      message,
      customProgress,
      shouldHideToast,
    }: ToastCustomProgress) => any,
  ): this;
}

class ToastCustomProgressEmitter extends EventEmitter {
  constructor() {
    super();
  }

  setCustomProgress = ({
    toastId,
    customProgress,
    message,
    shouldHideToast = false,
  }: ToastCustomProgress) => {
    if (!toastId) {
      return;
    }
    this.emit("onCustomProgress", {
      toastId,
      customProgress,
      message,
      shouldHideToast,
    });
  };
}

export const toastCustomProgressEmitter = new ToastCustomProgressEmitter();
